$(document).ready(function () {
    /**
    * TCR Module implementation
    */
    /* Commented out due to Safari:
       > undefined is not an object (evaluating 'this.mWindow['safari']') */
    // var tcr = document.createElement('script');
    // tcr.src = 'https://www2.gundrymdproplant.com/assets/js/site.js';
    // document.body.appendChild(tcr);

    // let results = {};
    // let value, key;
    // let objectStructure = null;
    // let index = 0;
    // function createObj(obj) {
    //     key = obj.closest('.box').find('h2').data('title');
    //     value = obj.closest('li').find('input').val();
    //     if (objectStructure == null) {
    //         results[key] = value;
    //     } else if (obj.closest('.box').hasClass('three')) {
    //         if (typeof results[key] === 'object') {
    //             results[key][index++] = value;
    //         } else {
    //             results[key] = {};
    //             results[key][index++] = value;
    //         }
    //         objectStructure = results
    //     } else {
    //         results[key] = value;
    //     }
    //     objectStructure = results;
    //     // console.log(objectStructure);
    //     funnelEventEmitter('surveyResults', objectStructure);
    // }

    const sixSurvey = typeof sixQuestions !== 'undefined' && sixQuestions ? true : false;
    let progressBarWidth = 100 / 6;

    const fillProgressBarOnSplitQuestion = () => {
        const progressBar = document.getElementById('formProgressBar');
        if (progressBar) {
            progressBarWidth += 100 / 6 / 3
            progressBar.style.setProperty('--progressBarWidth', progressBarWidth + '%');
        }
    }

    const fillProgressBarOnMoveToNextQuestion = (nextBoxNumber) => {
        const nextBox = $(`.box.${nextBoxNumber}`); 
        const progressBar = document.getElementById('formProgressBar');
        if (progressBar) {
            if (nextBox.attr('data-split') == 'true') progressBarWidth += 100 / 6 / 3
            else progressBarWidth += 100 / 6
            document.getElementById('formProgressBar').style.setProperty('--progressBarWidth', progressBarWidth + '%');
        }
    }

    const surveyForm = $('#surveyForm');
    const skipQuestion = $('#skipQuestion');
    const onProceedClick = (boxNumber, nextBoxNumber) => {
        surveyForm.removeClass(boxNumber).addClass(nextBoxNumber);
        skipQuestion.removeClass('gtm-skip-' + boxNumber).addClass('gtm-skip-' + nextBoxNumber);
        surveyForm.removeClass('answer1').removeClass('answer2')
        fillProgressBarOnMoveToNextQuestion(nextBoxNumber)
    }

    const boxesPagination = () => {
        if (surveyForm.hasClass('one')) {
            onProceedClick('one', 'two')
        } else if (surveyForm.hasClass('two') ) {
            onProceedClick('two', 'three')
        } else if (surveyForm.hasClass('three')) {
            onProceedClick('three', 'four')
        } else if (surveyForm.hasClass('four')) {
            onProceedClick('four', 'five')
        } else if (surveyForm.hasClass('five')) {
            onProceedClick('five', 'six')
        }
    }

    function pagination() {
        const boxes = $('.boxes');

        $('#nextStep').addClass('hidden');

        const handleSplitAndCommonAnswerClick = (boxNumber, nextBoxNumber, order) => {
            const box = $(`.box.${boxNumber}`);
            if (box.attr('data-split') == 'true') {
                if (!box.hasClass(order)) {
                    box.addClass(order)
                    surveyForm.addClass(order)
                    skipQuestion.addClass('gtm-skip-' + order)
                }
                if (box.hasClass('answer1') && box.hasClass('answer2')) {
                    $('#proceedStep').removeClass('hidden').addClass('show');
                }
                fillProgressBarOnSplitQuestion()
            } else {
                surveyForm.removeClass(boxNumber).addClass(nextBoxNumber);
                skipQuestion.removeClass('gtm-skip-' + boxNumber).addClass('gtm-skip-' + nextBoxNumber);
                fillProgressBarOnMoveToNextQuestion(nextBoxNumber)
            }

            /** Scroll page to the top after answer is clicked, except if on last question */
            $('html, body').animate({
                scrollTop: $("body").offset().top
            }, 1000);
        }

        const onAnswersClick = (answer, order) => {
            if (answer.parent().attr('data-answer') == 'checkbox') {
                answer.toggleClass('selected');
                $('#proceedStep').removeClass('hidden').addClass('show');

            } else {
                $(`.answers.${order} li`).removeClass('selected');
                answer.addClass('selected');
            }

            if (surveyForm.hasClass('one')) {
                handleSplitAndCommonAnswerClick('one', 'two', order)
            } else if (surveyForm.hasClass('two') && answer.parent().attr('data-answer') == 'radio') {
                handleSplitAndCommonAnswerClick('two', 'three', order)
            } else if (surveyForm.hasClass('three') && answer.parent().attr('data-answer') == 'radio' && sixSurvey) {
                handleSplitAndCommonAnswerClick('three', 'four', order)
            } else if (surveyForm.hasClass('four') && answer.parent().attr('data-answer') == 'radio' && sixSurvey) {
                handleSplitAndCommonAnswerClick('four', 'five', order)
            } else if (surveyForm.hasClass('five') && answer.parent().attr('data-answer') == 'radio' && sixSurvey) {
                handleSplitAndCommonAnswerClick('five', 'six', order)
            } else if (surveyForm.hasClass('six') && answer.parent().attr('data-answer') == 'radio' && sixSurvey) {
                if (!$('.box.six').hasClass(order)) {
                    $('.box.six').addClass(order)
                    surveyForm.addClass(order)
                    skipQuestion.addClass('gtm-skip-' + order)
                    fillProgressBarOnSplitQuestion()
                }
            }
        }

        $('.answers.answer1 li').on('click', function () {
            onAnswersClick($(this), 'answer1')
        });

        $('.answers.answer2 li').on('click', function () {
            onAnswersClick($(this), 'answer2')
        });

        $('#proceedStep').on('click', function() {
            boxesPagination()

            $('#proceedStep').removeClass('show').addClass('hidden');
        })

        if (sixSurvey) {
            const onProceed = () => {
                $('#nextStep').removeClass('hidden').addClass('show');
                $('.boxes.six .box').addClass('clicked');
                $('.skip').addClass('clicked');
            }
            const sixthBoxProceed = (order) => {
                const sixthBox = $(`.box.six`);
                if (sixthBox.attr('data-split') == 'true') {
                    if (!sixthBox.hasClass(order)) {
                        sixthBox.addClass(order)
                        surveyForm.addClass(order)
                    }
                    if (sixthBox.hasClass('answer1') && sixthBox.hasClass('answer2')) {
                        onProceed()
                    }
                } else {
                    onProceed()
                }
            }

            $('.box.six .answers.answer1 li').on('click', function () {
                sixthBoxProceed('answer1')
            });
    
            $('.box.six .answers.answer2 li').on('click', function () {
                sixthBoxProceed('answer2')
            });
        } else {
            $('.box.three .answers li').on('click', function () {
                $('#nextStep').removeClass('hidden').addClass('show');
                $('.boxes.three .box').addClass('clicked');
                $('.skip').addClass('clicked');
            });
        }      
    }

    // if ($(window).width() < 1024 || $('body').hasClass('surveyPage--v03')) {
    //     $('.answers > li').on('click', function () {
    //         // const boxes = $('.boxes');
    //         createObj($(this));
    //     })
    // } else {
    //     $('.answers label, .answers input').on('click', function () {
    //         // const boxes = $('.boxes');
    //         createObj($(this));
    //     })
    // }

    if (!$('body').hasClass('surveyPage--desktop') || $(window).width() <= 1024 || $('body').hasClass('surveyPage--v03') || $('body').hasClass('surveyPage--progressBar')) {
        pagination();
    }

    $('#nextStep').on('click', function () {

    })

    $('a[data-param]:not([data-content])').on('click', function(e) {
        e.preventDefault();

        let url = $(this).attr('href');
        let checkedAnswers;

        if (typeof redesignWithProgressBar !== 'undefined' && redesignWithProgressBar) checkedAnswers = $('.answers__item.selected input')
        else checkedAnswers = $('.answers__item input:checked');

        let paramsToForward;
        
        let paramsConcat = '';
        
        $(checkedAnswers).each(function(item, index){
            paramsToForward = $(checkedAnswers[item]).data('param-fw');
            const thisParamValue = $(checkedAnswers[item]).attr('id').toLocaleLowerCase();
           
            if (paramsToForward == true) {
                paramsConcat += thisParamValue + '_';
            }
        });
        
        // console.log(paramsToForward && url.length && url.includes('?'));

        /**
         * manipulate array to remove last array item '_'
         */
        let paramsConcatOnly = paramsConcat.slice(0, -1);

        console.log('paramsConcatOnly', paramsConcatOnly);

        if (paramsToForward && url.length && url.includes('?')) {
            url = url + `&fw_survey=${paramsConcatOnly}`;

        } else if (paramsToForward && url.length && !url.includes('?')) {
            url = url + `?fw_survey=${paramsConcatOnly}`;            
        }   
        
        if ($(this).hasClass('skip') && !surveyForm.hasClass('six') && typeof skipToNextQuestion !== 'undefined' && skipToNextQuestion) {
            boxesPagination()
            return
        }

        if($('#queueModal').length) {
            setTimeout(function () {
                window.location.href = url;
            }, 5000);
        } else if ($('#reportModal').length) {
            if ($(this).attr('id') == 'reportScreenNextStep') window.location.href = url;

            if ($(this).hasClass('skip') && !surveyForm.hasClass('six') && typeof skipToNextQuestion !== 'undefined' && skipToNextQuestion) {
                boxesPagination()
            } else {
                setTimeout(() => {
                    $('#reportModal').modal('show');
                    const progressBar = document.getElementById('progress');
                    
                    let width = 0;
                    const interval = setInterval(() => {
                        width++;
                        progressBar.style.setProperty('--barWidth', width + '%');
                        $('.progressBar__percentage').text(width + '%');
        
                        if (width >= 100) {
                            progressBar.style.setProperty('--barBorderRadius', '8px');
                            clearInterval(interval);
    
                            setTimeout(() => {
                                $('#reportModal').modal('hide');
                                $('.survey-wrap').hide();
                                window.scrollTo(0, 0);
                                $('.reportScreen').show();
                                $('.footer').hide();

                                if ($('#fixedCTA').length > 0) {
                                    const reportScreen = document.getElementById('reportScreen');
                            
                                    const fixedCtaHeight = document.getElementById('fixedCTA').clientHeight;
                                    reportScreen.style.setProperty('--fixedCTA-height', fixedCtaHeight + 'px');
                                }
                            }, progressBarPopUpCloseTime*1000);
                        }
                    }, progressBarTimeToFill*10);
                }, 500);
            }
        } else {
            window.location.href = url;
        }
    });
});